import React from "react";
import ReactDOM from "react-dom/client";
import 'bootstrap/dist/css/bootstrap.min.css';
import "@radix-ui/themes/styles.css";
import "./global.css";
import App from "./App";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import { createBrowserHistory } from "history";
import { PostHogProvider } from "posthog-js/react";

// Create custom history object
const history = createBrowserHistory({ window });

// Override the history.push method to prevent security checks
const originalPush = history.push;
const originalReplace = history.replace;

history.push = function(...args) {
  try {
    return originalPush.apply(this, args);
  } catch (error) {
    console.warn('Navigation error suppressed:', error);
    window.location.href = args[0];
  }
};

history.replace = function(...args) {
  try {
    return originalReplace.apply(this, args);
  } catch (error) {
    console.warn('Navigation error suppressed:', error);
    window.location.href = args[0]; 
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));

// Use HistoryRouter with our custom history object and wrap with PostHogProvider
root.render(
  <HistoryRouter history={history}>
    <React.StrictMode>
      <PostHogProvider
        apiKey={process.env.REACT_APP_POSTHOG_KEY}
        options={{
          api_host: process.env.REACT_APP_POSTHOG_HOST,
          defaults: '2025-05-24',
          capture_exceptions: true, // This enables capturing exceptions using Error Tracking
          debug: process.env.NODE_ENV === "development",
        }}
      >
        <App />
      </PostHogProvider>
    </React.StrictMode>
  </HistoryRouter>
);